import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filter",
  "use": "filter-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" id=\"filter\"><path fill=\"none\" stroke=\"currentColor\" d=\"M29 13.18l-19-.117M25.24 10v6.679M29 20.25l-19-.116m4.948-3.282v6.68m6.333-.212V30M29 26.536l-19-.115\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol